module.exports = __webpack_public_path__ + "static/img/Innerbanner.76a2e8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Innerbanner.png
// module id = 207
// module chunks = 1